import { HeadCell } from '../../../types/table';
import { EntitlementRowData } from './entitlements-ui-types';

export const entitlementTableHeaderCells: readonly HeadCell<EntitlementRowData>[] = [
  {
    id: 'claims',
    label: 'Applicable claims',
    key: 'claims',
  },
  {
    id: 'process',
    label: 'Process',
    key: 'process',
  },
  {
    id: 'system',
    label: 'System',
    key: 'system',
  },
  {
    id: 'sourceId',
    label: 'Source ID',
    key: 'sourceId',
  },
  {
    id: 'earliestValidFrom',
    label: 'Earliest valid from',
    key: 'earliestValidFrom',
  },
  {
    id: 'latestValidTo',
    label: 'Latest valid to',
    key: 'latestValidTo',
  },
  {
    id: 'importedBy',
    label: 'Imported by',
    key: 'importedBy',
  },
  {
    id: 'expand',
    label: '',
  },
  {
    id: 'edit',
    label: '',
  },
  {
    id: 'active',
    label: '',
  },
];

export default entitlementTableHeaderCells;
